// extracted by mini-css-extract-plugin
export default {"label-with-count":"hcsw4aNUIqu7L4r6y3tq","count":"fG9DztQQmFP_R_V4Rwkc","count-zero":"GJYDjREioF74lHAA4Lxe"};